/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ format: NonNullable<unknown> }} Ui_Pace_Est_Race_TimeInputs */

const en_ui_pace_est_race_time = /** @type {(inputs: Ui_Pace_Est_Race_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Race Time (${i?.format})`)
};

const de_ui_pace_est_race_time = /** @type {(inputs: Ui_Pace_Est_Race_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wettkampfzeit (${i?.format})`)
};

/**
* | output |
* | --- |
* | "Race Time ({format})" |
*
* @param {Ui_Pace_Est_Race_TimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pace_est_race_time = /** @type {((inputs: Ui_Pace_Est_Race_TimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pace_Est_Race_TimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pace_est_race_time(inputs)
	return de_ui_pace_est_race_time(inputs)
});